
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/colecoes",
      function () {
        return require("private-next-pages/colecoes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/colecoes"])
      });
    }
  